export default __webpack_public_path__ + "static/media/NIAS0350.34I-32912_-17929_0.78d96cca.jpg";